"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuyFormContext = void 0;
const react_1 = require("react");
const form_1 = require("../types/form");
exports.BuyFormContext = (0, react_1.createContext)({
    current: {},
    onChange: () => { },
    errors: {},
    formStatus: form_1.FormStatus.INIT,
    validateFieldBuilder: () => () => undefined,
    messageFactory: () => '',
});
